import React from 'react';

import { Button } from '@mui/material';

export function DigitSsoButton({ digitSsoLink }) {
  return (
    <Button
      variant='contained'
      color='primary'
      sx={{
        padding: '8px 24px',
        fontSize: '18px',
        '&:hover': { color: 'primary.light', backgroundColor: 'digitregroup.light' },
      }}
      href={digitSsoLink}
    >
      Se connecter
    </Button>
  );
}
